import type { CheckboxRootProps } from '@base-ui/react';

import { Checkbox as BaseCheckbox, Field as BaseField } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Icon } from '../../Icon/Icon';
import { boxStyle, checkboxControlThemeStyle, contentStyle, fieldItemStyle, indicatorStyle } from './CheckboxRoot.css';

type Props = CheckboxRootProps;

export const CheckboxRoot = ({ children, ...delegated }: Props) => {
  return (
    <BaseField.Item className={checkboxControlThemeStyle}>
      <label className={fieldItemStyle}>
        <BaseCheckbox.Root {...delegated} className={clsxs(boxStyle, delegated.className)}>
          <BaseCheckbox.Indicator
            className={indicatorStyle}
            render={(props, state) => <Icon {...props} name={state.indeterminate ? 'CheckIndeterminate' : 'Check'} size={20} />}
          />
        </BaseCheckbox.Root>

        {children && <div className={contentStyle}>{children}</div>}
      </label>
    </BaseField.Item>
  );
};
